import type { MenuAudience, MenuEntry } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export type MenuEntryOrigin = "default" | "org" | "group" | "location";

export interface ResolvedMenuEntry extends MenuEntry {
  origin: MenuEntryOrigin;
  /** When `origin !== "default"`, the DB row id (for revert/delete). */
  rowId?: number;
}

export interface UpsertMenuEntryFields extends Partial<Omit<MenuEntry, "optionId" | "isCustom">> {
  isCustom?: boolean;
}

//LINK - apps/server/src/API/Menu/Menu.Controller.ts
export class MenuAPI {
  static async getEffectiveMenu(orgId: number, groupId?: number, locationId?: number): Promise<ResolvedMenuEntry[]> {
    const params: Record<string, unknown> = {};
    if (groupId) params.groupId = groupId;
    if (locationId) params.locationId = locationId;
    return APIService.Server.get<ResolvedMenuEntry[]>(`/menu/org/${orgId}`, params);
  }

  static async upsertEntry(
    orgId: number,
    optionId: string,
    fields: UpsertMenuEntryFields,
    scope: { groupId?: number; locationId?: number } = {}
  ): Promise<{ id: number }> {
    return APIService.Server.post<{ id: number }>(`/menu/org/${orgId}/entry`, { optionId, fields, ...scope });
  }

  static async deleteEntry(orgId: number, entryId: number): Promise<{ ok: boolean }> {
    return APIService.Server.delete<{ ok: boolean }>(`/menu/org/${orgId}/entry/${entryId}`);
  }
}

// Re-export for callers that want the Menu types alongside.
export type { MenuAudience, MenuEntry };
